import { Constants } from '../../constants';

const baseUrl: string = Constants.CARD_CONNECT_IFRAME_URL + '?usecvv=true&useexpiry=true&invalidinputevent=true&invalidexpiryevent=true&invalidcvvevent=true&tokenizewheninactive=true&tokenizewheninactive=true&inactivityto=100&autofocus=true&css='
const css: string = `
    .error,
    .error:focus { 
        border-color: red;
    }
    
    body { 
        margin: 0; 
    } 
    
    input { 
        box-sizing: 
        border-box; 
        font-family: Arial; 
        font-size: 14px; 
        width: 60%;
        min-width: 200px;
        max-width: 345px;
        color: rgb(85,85,85); 
        background: white; 
        border-style: solid;
        border-width: 2px;
        border-color: rgb(195,195,195); 
        border-radius: 4px; 
        padding: 8px 48px 8px 8px; 
        outline: none;
        margin-top: 5px;
        margin-bottom: 5px;

    } 

    select {
        box-sizing: 
        border-box; 
        font-family: Arial; 
        font-size: 14px; 
        width: 20%;
        min-width: 70px;
        max-width: 140px;
        color: rgb(85,85,85); 
        background: white; 
        border-style: solid;
        border-width: 2px;
        border-color: rgb(195,195,195); 
        border-radius: 4px; 
        padding: 8px; 
        outline: none;
        margin-top: 5px;
        margin-bottom: 5px;
    }
    
    input:focus { 
        border-style: solid;
        border-width: 2px;
        border-color: rgb(23,108,231);
        outline: none;
    }

    select:focus {
        border-style: solid;
        border-width: 2px;
        border-color: rgb(23,108,231);
        outline: none;
    }

    label {
        display: inline-block;
        max-width: 100%;
        font-weight: 700;
        font-size: 0.8rem;
        color: rgba(0,0,0,.87);
        font-family: Open Sans, helvetica, arial, sans-serif;
        letter-spacing: -0.02em;
    }

`;

export const IFRAME_URL: string = baseUrl + encodeURI(css).replace('@','%40') + "%23cccvvfield%7Bwidth%3A30%25%3Bmin-width%3A100px%3Bmax-width%3A190px%3B%7D";


// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/credit-card-iframe/cred-card-iframe.config.ts